const { h, render, Component } = require('preact');
const ArticlesList = require('./articles_list')
const TrendingArticlesHeaderView = require('../../views/search/trending_articles_header')

class SearchResults extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    if (this.props.results.search && this.props.results.trendingArticles){
      let trendingArticlesHeader = null, articles = [];
      if (this.props.results.search.contents.length == 0){
        trendingArticlesHeader = <TrendingArticlesHeaderView />
        articles = this.props.results.trendingArticles.contents;
      }
      else{
        articles = this.props.results.search.contents;
      }

      return (
        <div class="search-results-section">
          <p>
            {I18n.translate("js.modules.faq.search_result")} <span class="search-text">{this.props.searchText}</span>
          </p>
          {trendingArticlesHeader}
          <ArticlesList
            articles={articles}
            searchText={this.props.searchText} handleNeedHelpFromSearchResults={this.props.handleNeedHelpFromSearchResults}
            onGuestHelp={this.props.onGuestHelp}
            showGuestHelp={this.props.showGuestHelp}
          />
        </div>
      )
    }
    return null;
  }
}
module.exports = SearchResults
